import A11yDialog from 'a11y-dialog'

document.addEventListener('DOMContentLoaded', () => {
    const modalContainers = document.querySelectorAll('.c-modal')
    const body = document.querySelector('body')

    modalContainers.forEach((container) => {
        const dialog = new A11yDialog(container)
        dialog.on('show', () => {
            if (body) {
                body.classList.add('modal-open')
            }
        })
        dialog.on('hide', () => {
            if (body) {
                body.classList.remove('modal-open')
            }
            if (container.id === 'pressed-modal') {
                container.querySelector('.c-modal__content').innerHTML =
                    '<p>Loading...</p>'
            }
        })

        /**
         * Not needed, but good reference
        const openButton = document.querySelector('[data-a11y-dialog-show]');
        if (openButton) {
            openButton.addEventListener('click', () => {
                dialog.show();
            });
        }
        */
    })
})
